// extracted by mini-css-extract-plugin
export var activeLink = "pagination-module--active-link--0fd19";
export var paginationNumbersContainer = "pagination-module--pagination-numbers-container--a1895";
export var paginationWrapper = "pagination-module--pagination-wrapper--f5c32";